// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poll[data-v-0fe9428d] {
  flex: 1;
}
.poll input[data-v-0fe9428d],
.poll .custom-textarea[data-v-0fe9428d] {
  display: block;
  width: 100%;
  font-size: 16px;
  border: none;
  border-bottom: 1px solid var(--asc-item-border-bottom);
  outline: none;
  background-color: var(--input-bg-color);
}
.poll input[data-v-0fe9428d]::placeholder,
.poll .custom-textarea[data-v-0fe9428d]::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ccc !important;
  opacity: 1;
  /* Firefox */
}
.poll input[data-v-0fe9428d]:-ms-input-placeholder,
.poll .custom-textarea[data-v-0fe9428d]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc !important;
}
.poll input[data-v-0fe9428d]::-ms-input-placeholder,
.poll .custom-textarea[data-v-0fe9428d]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #ccc !important;
}
.poll input[data-v-0fe9428d]:focus,
.poll .custom-textarea[data-v-0fe9428d]:focus {
  border-bottom: 1px solid #165FCF;
  color: var(--main-body-color);
}
.poll .custom-textarea[data-v-0fe9428d] {
  height: auto;
}
.poll .focus[data-v-0fe9428d] {
  border-bottom: 1px solid #165FCF;
  color: var(--main-body-color);
}
.poll .poll-input-title[data-v-0fe9428d] {
  margin-bottom: 40px;
  outline: none;
}
.poll .poll-input-question[data-v-0fe9428d] {
  margin-bottom: 20px;
}
.poll .poll-input-red[data-v-0fe9428d] {
  border-bottom: 1px solid var(--elem-red-color);
}
.poll .poll-input-red[data-v-0fe9428d]::placeholder {
  color: var(--elem-red-color) !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/PollEditor.vue"],"names":[],"mappings":"AAAA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sDAAsD;EACtD,aAAa;EACb,uCAAuC;AACzC;AACA;;EAEE,yCAAyC;EACzC,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;;EAEE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,uCAAuC;AACzC","sourcesContent":[".poll[data-v-0fe9428d] {\n  flex: 1;\n}\n.poll input[data-v-0fe9428d],\n.poll .custom-textarea[data-v-0fe9428d] {\n  display: block;\n  width: 100%;\n  font-size: 16px;\n  border: none;\n  border-bottom: 1px solid var(--asc-item-border-bottom);\n  outline: none;\n  background-color: var(--input-bg-color);\n}\n.poll input[data-v-0fe9428d]::placeholder,\n.poll .custom-textarea[data-v-0fe9428d]::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #ccc !important;\n  opacity: 1;\n  /* Firefox */\n}\n.poll input[data-v-0fe9428d]:-ms-input-placeholder,\n.poll .custom-textarea[data-v-0fe9428d]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #ccc !important;\n}\n.poll input[data-v-0fe9428d]::-ms-input-placeholder,\n.poll .custom-textarea[data-v-0fe9428d]::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #ccc !important;\n}\n.poll input[data-v-0fe9428d]:focus,\n.poll .custom-textarea[data-v-0fe9428d]:focus {\n  border-bottom: 1px solid #165FCF;\n  color: var(--main-body-color);\n}\n.poll .custom-textarea[data-v-0fe9428d] {\n  height: auto;\n}\n.poll .focus[data-v-0fe9428d] {\n  border-bottom: 1px solid #165FCF;\n  color: var(--main-body-color);\n}\n.poll .poll-input-title[data-v-0fe9428d] {\n  margin-bottom: 40px;\n  outline: none;\n}\n.poll .poll-input-question[data-v-0fe9428d] {\n  margin-bottom: 20px;\n}\n.poll .poll-input-red[data-v-0fe9428d] {\n  border-bottom: 1px solid var(--elem-red-color);\n}\n.poll .poll-input-red[data-v-0fe9428d]::placeholder {\n  color: var(--elem-red-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
